import React from "react";
import { TurnOnOffModalContent } from "./turn-on-off-modal-content.component";
import { ReplaceCardModalContent } from "./replace-card-modal-content.component";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";
import { TravelExemptionModalContent } from "./travel-exemption-modal-content.component";
import { CancelTravelExemptionModalContent } from "./cancel-travel-exemption-modal";
import moment from "moment";

const CardControlsModal = (props) => {
  let showCloseIcon = props.showCloseIcon;

  let cleanupFunction = () => {
    if (popupMenuOptions.invalid.ExistingTravelExemption) {
      props.setTravelExemptionEligibility({});
    }
  };

  // default to the card on/off modal
  let ModalContentToDisplay = TurnOnOffModalContent;

  switch (props.optionType) {
    case popupMenuOptions.valid.ReplaceCard:
      ModalContentToDisplay = ReplaceCardModalContent;
      break;
    case popupMenuOptions.invalid.CardStatusInvalid:
      ModalContentToDisplay = () => (
        <div>Please call us at 888-267-7200 for help with resetting your pin.</div>
      );
      break;
    case popupMenuOptions.invalid.ReplaceCardSuspiciousActivity:
      ModalContentToDisplay = () => (
        <div>Please call us at 877-445-0728 for help with suspicious activity on your card.</div>
      );
      break;
    case popupMenuOptions.invalid.IneligibleReplaceCard:
      ModalContentToDisplay = () => (
        <div>We are unable to complete this request online. Please give us a call at 888-267-7200 to request a replacement card.</div>
      );
      break;
    case popupMenuOptions.other.EligibleTravelExemption:
      ModalContentToDisplay = TravelExemptionModalContent;
      break;
    case popupMenuOptions.invalid.IneligibleTravelExemption:
      ModalContentToDisplay = () => (
        <div>Please call us at 888-267-7200 for help with placing a Travel Exemption.</div>
      );
      break;
    case popupMenuOptions.invalid.ExistingTravelExemption:
      ModalContentToDisplay = () => {
        const currentEndDate = props.authPayment.travelExemptionEligibility.CurrentExemptionEndDate;
        const formattedDate = moment(currentEndDate).format("MM/DD/YYYY");

        return (
          <div className="f12">
            <div>Travel Exemption in effect until {formattedDate}.</div>
            <div>To change or cancel, please give us a call at:</div>
            <div className="mt-3">Lake Trust: (888)267-7200</div>
            <div>Card Services Domestic: (855)671-0078</div>
            <div>Card Services International: (301)837-8443</div>
          </div>
        );
      };
      break;
    case popupMenuOptions.valid.CancelExistingTravelExemption:
      ModalContentToDisplay = CancelTravelExemptionModalContent;
  }
  const closeModal = () => {
    cleanupFunction();
    props.hideModal();
  };

  return (
    <div className={`${props.show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg"></div>
      <div className="modal px-1" style={{ maxHeight: "75%", minHeight: "425px", position: "fixed", overflowY: "initial !important"}}>
        <div class="modal-container py-5 px-3 m-auto" style={{ maxWidth: "90%", overflowY: "auto" }}>
          <button
            onClick={closeModal}
            className="close-icon"
            style={{ visibility: showCloseIcon ? "visible" : "hidden" }}
          >
            <i class="material-icons">close</i>
          </button>
          <ModalContentToDisplay {...props} closeModal={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default CardControlsModal;



// WEBPACK FOOTER //
// ./src/components/card-controls/modal/card-controls-modal.component.js